import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from '@heroicons/react/24/outline';

export const ProductCard = ({ 
  name, 
  description, 
  features, 
  icon, 
  price, 
  isPopular = false,
  cta = "Más Información",
  linkTo = "/contact"
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-lg p-8 relative ${
      isPopular ? 'ring-2 ring-blue-600 transform scale-105' : ''
    }`}>
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-blue-500 text-white px-4 py-1 rounded-full text-sm font-medium">
            Más Popular
          </span>
        </div>
      )}
      
      <div className="text-center mb-8">
        <div className="text-blue-600 mb-4 flex justify-center">
          {icon}
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{name}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        {price && (
          <div className="text-3xl font-bold text-blue-600">{price}</div>
        )}
      </div>

      <ul className="space-y-4 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <CheckIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
            <span className="text-gray-700">{feature}</span>
          </li>
        ))}
      </ul>

      <Link
        to={linkTo}
        className={`w-full block text-center py-3 px-4 rounded-lg font-medium transition-colors duration-200 ${
          isPopular
            ? 'bg-blue-500 text-white hover:bg-blue-600'
            : 'bg-gray-900 text-white hover:bg-gray-800'
        }`}
      >
        {cta}
      </Link>
    </div>
  );
};
